<template>
  <div class="activity-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">活动名称：</span>
          </div>
          <el-input v-model="formData.name" size="small" style="width: 240px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">活动地址：</span>
          </div>
          <el-input v-model="formData.address" size="small" style="width: 240px" />
        </div>
        <div class="form-line" style="margin: 0;align-items: center;">
          <div class="textBox" style="margin-right: 18px;">
            <b class="red">*</b>
            <span class="line-text">封面图：</span>
          </div>
          <!--<upload-img-list @getImgList="getImgList"  />-->
          <input id="uploadGuidedGraph" name="file" accept="image/*" type="file"
                 @change="upData2" style="display: none" />
          <div>
            <a class="newly2" @click="upImg2" v-if="!formData.coverPicture">
              <span><i class="el-icon-plus"></i></span>
              <span>点击上传</span>
            </a>
            <a class="upload2" @click="upImg2" v-if="formData.coverPicture">
              <img :src="formData.coverPicture" id="packBg" />
              <b>重新上传</b>
            </a>
          </div>
        </div>
      </div>

      <div style="display: flex;justify-content: flex-start;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">联系人姓名：</span>
          </div>
          <el-input v-model="formData.responsiblePersonName" size="small" style="width: 240px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">联系人手机：</span>
          </div>
          <el-input v-model="formData.responsiblePersonPhone" size="small" style="width: 240px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">关联门禁：</span>
          </div>
          <el-select v-model="formData.deviceCode" size="small" style="width: 240px">
            <el-option v-for="item in accessDeviceList" :key="item.deviceCode"
                       :label="item.deviceName" :value="item.deviceCode">
            </el-option>
          </el-select>
        </div>
      </div>

      <div style="display: flex;justify-content: flex-start;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">活动起始时间：</span>
          </div>
          <el-date-picker v-model="formData.eventStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width: 240px" placeholder="选择活动起始时间"></el-date-picker>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">活动结束时间：</span>
          </div>
          <el-date-picker v-model="formData.eventEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width: 240px" placeholder="选择活动结束时间"></el-date-picker>
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">人员限制：</span>
          </div>
          <el-input v-model="formData.personLimitNumber" size="small" style="width: 240px" >
            <template slot="append">人</template>
          </el-input>
        </div>
      </div>

      <div style="display: flex;justify-content: flex-start;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">报名起始时间：</span>
          </div>
          <el-date-picker v-model="formData.applyStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width: 240px" placeholder="选择报名起始时间"></el-date-picker>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">报名结束时间：</span>
          </div>
          <el-date-picker v-model="formData.applyEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width: 240px" placeholder="选择报名结束时间"></el-date-picker>
        </div>
      </div>

      <div style="display: flex;justify-content: flex-start;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">活动类型：</span>
          </div>
          <div style="width: 240px">
            <el-radio-group v-model="formData.type" size="mini">
              <el-radio label="FREE" border>免费</el-radio>
              <el-radio label="CHARGE" border>收费</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="form-line" v-if="formData.type === 'CHARGE'">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">报名费用：</span>
          </div>
          <el-input v-model="formData.unitPersonPrice" size="small" style="width: 240px" >
            <template slot="append">元/人</template>
          </el-input>
        </div>
        <div class="form-line" v-if="formData.type === 'CHARGE'">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">收款账户：</span>
          </div>
          <el-select v-model="formData.accountCode" size="small" style="width: 240px">
            <el-option v-for="item in accountList" :key="item.code"
                       :label="item.mchName" :value="item.code">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">活动详情：</span>
        </div>
        <div class="editorBox">
          <quill-editor ref="QuillEditor"
                        v-model="formData.introduction"
                        class="ql-editor"
                        :options="editorOption"
                        @blur="onEditorBlur($event)"
                        @focus="onEditorFocus($event)"
                        @ready="onEditorReady($event)">
          </quill-editor>
        </div>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/activity'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import UploadImgList from '../../../components/Input/UploadImgList'

  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction

    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],

    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image'],
    ['clean']                                         // remove formatting button
  ]

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'activity-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧活动',
          name: 'activity-manage'
        }, {
          value: '活动管理'
        }],
        mainTitle: '添加活动',
        subheading: '',

        itemList: [],
        pictureBase64: '',

        editorOption: {
          modules: {
            toolbar: {
              container: toolbarOptions,  // 工具栏
              handlers: {
                'image': function (value) {
                  if (value) {
                    document.querySelector('#showImageDialogVisible').click()
                  } else {
                    this.quill.format('image', false);
                  }
                }
              }
            }
          }
        },

        formData: {
          name: '',
          address: '',
          deviceCode: '',
          deviceName: '',
          introduction: '',
          personLimitNumber: '',
          responsiblePersonName: '',
          responsiblePersonPhone: '',
          eventStartTime: '',
          eventEndTime: '',
          applyStartTime: '',
          applyEndTime: '',
          coverPicture: '',
          type: 'FREE',
          unitPersonPrice: '',
          accountCode: '',
          accountName: '',
        },
        accessDeviceList: [],
        accountList: [],
        responsiblePersonList: [],
      }
    },
    created () {
      this.getAccountList()
      this.getAccessDeviceList()
    },
    methods: {
      // 查询门禁列表
      getAccessDeviceList () {
        this.$axios.get(`${api.getAccessDeviceList}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let list = res.data.data
              this.accessDeviceList = list
            }
          })
          .catch(errorHandler('查询失败'))
      },
      // 查询账户列表
      getAccountList () {
        this.$axios.get(`${api.getAccountList}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let list = res.data.data
              this.accountList = list
            }
          })
          .catch(errorHandler('查询失败'))
      },
      onEditorBlur(editor) {},
      onEditorFocus(editor) {},
      onEditorReady(editor) {},
      onEditorChange({ editor, html, text }) {
        // console.log('editor change!', editor, html, text)
        this.formData.introduction = html
      },
      toManagePage () {
        this.$router.push({
          name: 'activity-manage'
        })
      },

      upData2: function () {
        let that = this
        const oFReader = new FileReader()
        const file = document.getElementById('uploadGuidedGraph').files[0]
        if (file.size > 1024 * 1024) {
          nError('上传图片不能大于1M')
          return false
        }
        oFReader.readAsDataURL(file)
        oFReader.onloadend = function (oFRevent) {
          const src = oFRevent.target.result
          that.pictureBase64 = src
          that.uploadPicture()
        }
      },
      upImg2: function () {
        document.getElementById('#uploadBackgroundImg')
        $('#uploadGuidedGraph')
          .click() // 隐藏了input:file样式后，点击头像就可以本地上传
          .on('change', function () {
            // const objUrl = getObjectURL(this.files[0])
            // if (objUrl) {
            //   $('#pic2').attr('src', objUrl)
            // }
          })
      },

      // 上传图片
      uploadPicture () {
        this.$axios.post(api.uploadImg, {
          picData: this.pictureBase64
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.formData.coverPicture = res.data.data
            } else {
              // 提示信息，需引入Message
              nError('图片上传失败')
            }
          })
          .catch(errorHandler('图片上传失败'))
      },

      confirm () {
        if (!this.formData.name) {
          nError('请输入活动名称')
          return false
        }
        if (!this.formData.address) {
          nError('请输入活动地址')
          return false
        }
        if (!this.formData.coverPicture) {
          nError('请上传活动封面图')
          return false
        }
        if (!this.formData.responsiblePersonName) {
          nError('请输入活动联系人')
          return false
        }
        if (!this.formData.responsiblePersonPhone) {
          nError('请输入活动联系人手机')
          return false
        }
        if (!this.formData.eventStartTime) {
          nError('请输入活动起始时间')
          return false
        }
        if (!this.formData.eventEndTime) {
          nError('请输入活动结束时间')
          return false
        }
        if (!this.formData.applyStartTime) {
          nError('请输入报名起始时间')
          return false
        }
        if (!this.formData.applyEndTime) {
          nError('请输入报名结束时间')
          return false
        }
        if (!this.formData.introduction) {
          nError('请输入活动详情')
          return false
        }
        if (new Date(this.formData.applyStartTime).getTime() > new Date(this.formData.applyEndTime).getTime() || new Date(this.formData.eventStartTime).getTime() > new Date(this.formData.eventEndTime).getTime()) {
          nError('起始时间需在结束时间之前')
          return false
        }
        if (new Date(this.formData.applyStartTime).getTime() > new Date(this.formData.eventStartTime).getTime()) {
          nError('报名时间需在活动时间之前')
          return false
        }
        this.accountList.map(v => {
          if (v.code === this.formData.accountCode) {
            this.formData.accountName = v.mchName
          }
        })
        this.accessDeviceList.map(v => {
          if (v.deviceCode === this.formData.deviceCode) {
            this.formData.deviceName = v.deviceName
          }
        })
        this.$axios.post(api.addEvent, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.toManagePage()
      }
    },
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 120px;
    height: 90px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 28px;
    line-height: 40px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 120px;
    height: 90px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .activity-add {
    .el-switch {
      height: 30px;
    }
    .el-input-number.is-controls-right .el-input__inner {
      text-align: left;
    }

    .editorBox {
      min-height: 240px;
      .quill-editor {
        width: 1068px;
        min-height: 240px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
      }
      .ql-editor {
        padding: 0;
      }
      .ql-container {
        height: 60%;
        flex: 1;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/Activity/ActivityManage/ActivityAdd.vue